import { render, staticRenderFns } from "./business_detail.vue?vue&type=template&id=117faf20&scoped=true&"
import script from "./business_detail.vue?vue&type=script&lang=js&"
export * from "./business_detail.vue?vue&type=script&lang=js&"
import style0 from "./business_detail.vue?vue&type=style&index=0&id=117faf20&prod&lang=scss&scoped=true&"
import style1 from "./business_detail.vue?vue&type=style&index=1&id=117faf20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117faf20",
  null
  
)

export default component.exports